import React, { useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { countries } from 'countries-list';
import i18next from 'i18next';
import { tr } from 'helper/translate';

/** Country names in the backoffice language, sorted by name. */
const countryOptions = (language: string) => {
  const names = new Intl.DisplayNames([language], { type: 'region' });
  return Object.keys(countries)
    .map(code => ({ code, name: names.of(code) || code }))
    .sort((a, b) => a.name.localeCompare(b.name, language));
};

export function PdfImportCountry(props: { label: string; value: string; onChange: (code: string) => void; required?: boolean }) {
  const language = i18next.language === 'en' ? 'en' : 'de';
  const options = useMemo(() => countryOptions(language), [language]);
  return (
    <Autocomplete
      options={options}
      value={options.find(option => option.code === props.value) || null}
      getOptionLabel={option => option.name}
      isOptionEqualToValue={(a, b) => a.code === b.code}
      onChange={(_event, option) => props.onChange(option?.code || '')}
      renderInput={params => (
        <TextField
          {...params}
          label={props.label}
          required={props.required}
          placeholder={tr('pdf-import-country-placeholder')}
          helperText={!props.value ? tr('pdf-import-not-in-pdf') : undefined}
        />
      )}
    />
  );
}
